import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'

import { isDirtyForm } from '../../../utils/formHelpers'
import { FormModalContainer } from '../../Form'
import { useDraftFlushOnUnmount } from '../Draft.hooks'

import { getDraftFormPayload } from './DraftFormPopupContainer.utils'

function DraftFormPopupContainer({
  Confirmation,
  getDraftPayload = getDraftFormPayload,
  getIsDirty = isDirtyForm,
  getLatestDraft,
  setDraft,
  titleKey,
  onClose,
  onMinimize,
  onSubmitConfirm,
  ...containerProps
}) {
  const { t } = useTranslation()

  const { dirty, initialValues, values } = useFormikContext()

  // Save the draft continuously so that closing the modal via the title-bar X
  // ("save draft" pick on the close confirmation) doesn't drop in-progress
  // values — the close confirmation's onSubmit has no access to form values.
  useEffect(() => {
    if (getIsDirty({ dirty, initialValues, values })) {
      setDraft(getDraftPayload(values))
    }
  }, [values])

  useDraftFlushOnUnmount({
    getDraftPayload,
    getIsDirty,
    getLatestDraft,
    setDraft,
  })

  function handleMinimize() {
    if (getIsDirty({ dirty, initialValues, values })) {
      setDraft(getDraftPayload(values), 0)
    }

    onMinimize?.()
  }

  return (
    <FormModalContainer
      {...containerProps}
      Confirmation={Confirmation}
      getIsDirty={getIsDirty}
      title={t(titleKey)}
      onClose={onClose}
      onMinimize={onMinimize ? handleMinimize : undefined}
      onSubmitConfirm={onSubmitConfirm}
    />
  )
}

export default DraftFormPopupContainer
